import {Vue} from '~/addiesaas'
import RePageMashup from './page'
Vue.component(RePageMashup.name, RePageMashup)

export default {
  RePageMashup
}
